// A day's energy-goal thresholds — shared by the menu page's energy bar and the
// menu-history charts so both classify a day identically. Pure; all values kJ.

/** Lower/upper energy thresholds for a day. Below `lower` (goal − under
 * tolerance) is under-target; above `upper` is over-target; between is
 * on-target. The upper allowance is the LARGER of the over-tolerance and the
 * exercise bonus (not both) — so earning an exercise bonus doesn't stack a free
 * over-tolerance on top of it. */
export function energyThresholds(goalKj, bonusKj, underTolerancePct, overTolerancePct) {
  const goal = Number(goalKj) || 0;
  const under = (Number(underTolerancePct) || 0) / 100;
  const over = (Number(overTolerancePct) || 0) / 100;
  return {
    lower: goal * (1 - under),
    upper: goal + Math.max(goal * over, Math.max(0, Number(bonusKj) || 0)),
  };
}

/** Under/over/on-target classification of a day's energy against its thresholds. */
export function goalStatus(kj, lower, upper) {
  if (kj < lower) return 'under';
  if (kj > upper) return 'over';
  return 'on';
}
